export default {
    // my: {
    //     domain: window.location.protocol + '//' + window.location.host + '/',
    //     url: 'https://node-bluma.earth.polcode.com/v1/'
    // }
    // my: {
    //     domain: window.location.protocol + '//' + window.location.host + '/',
    //     url: 'http://localhost:3000/v1/'
    // }
    my: {
        domain: window.location.protocol + '//' + window.location.host + '/',
        url: 'https://datatool.workitaround.com/v1/'
    }
};
